import React, { Component } from 'react';
import { connect } from 'react-redux';

import {setPage, performRequest} from './actions.mjs';

class ProjectLoadMoreButton extends Component {
	loadMore(event) {
    	event.preventDefault();
    	if(!this.props.loading) {
	      this.props.dispatch(setPage(this.props.page + 1));
	      this.props.dispatch(performRequest({past: this.props.past}));
    	}
  	}

	render() {
		if(this.props.total > this.props.hits.length && this.props.translations !== null) {
			return (
				<div className="container text-center p-b-lg">
					<a href="#" onClick={(event) => this.loadMore(event)} className="btn cta cta--pink">{this.props.translations.next} <i className="la icon-la-arrow-down"></i></a>
				</div>
			)
		}
		return null;
	}
}
const mapStateToProps = (state) => {
  return {
    page: state.page,
    loading: state.loading,
    total: state.results.total,
    hits: state.results.hits,
    translations: state.translations,
    past: state.past
  };
};

export default connect(mapStateToProps)(ProjectLoadMoreButton);